/**
 * Maps a File object to the intervene send-message API type value.
 */
export function getUploadMessageType(file) {
  if (!file?.type) return 'file';

  const mime = file.type.toLowerCase();

  if (mime.startsWith('image/')) return 'image';
  if (mime.startsWith('video/')) return 'video';
  if (mime.startsWith('audio/')) return 'audio';
  if (
    mime.includes('pdf') ||
    mime.includes('document') ||
    mime.includes('msword') ||
    mime.includes('spreadsheet') ||
    mime.includes('text/plain')
  ) {
    return 'file';
  }

  return 'file';
}

export function appendMessageUpload(formData, file, caption = '') {
  formData.append('file', file);
  formData.append('type', getUploadMessageType(file));

  if (caption && getUploadMessageType(file) !== 'audio') {
    formData.append('text', caption);
  }
}
